import axios from "axios";
const api = process.env.REACT_APP_API_URL;

export const fetchAllRolesServie = async (
  pageNumber,
  pageSize,
  access_token,
  debouncedSearch = ""
) => {
  try {
    const filter = {
      shortName: debouncedSearch,
      description: debouncedSearch,
    };
    return axios.get(
      `${api}/RoleManagement/GetStudyRolesPagination?pageNumber=${
        debouncedSearch !== "" ? 1 : pageNumber
      }&pageSize=${pageSize}&Filter=${JSON.stringify(filter)}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const fetchAllPermsissionsService = async (roleId, access_token) => {
  try {
    return axios.get(
      `${api}/RoleManagement/LoadRolePermissionData?RoleId=${roleId}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const updateRolePermissionService = async (data, access_token) => {
  try {
    return axios.post(`${api}/RoleManagement/UpdateRolePermission`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const addNewRoleService = async (data) => {
  try {
    return axios.post(`${api}/RoleManagement/AddStudyRole`, data);
  } catch (err) {
    return err;
  }
};

export const getAllLandingPageService = async (access_token) => {
  try {
    return await axios.get(`${api}/RoleManagement/GetLandingPages`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "text/plain",
      },
    });
  } catch (err) {
    console.error("Error fetching landing pages:", err);
    return err;
  }
};

export const getRoleByIdService = async (roleId, access_token) => {
  try {
    return axios.get(`${api}/RoleManagement/GetStudyRoleById?Id=${roleId}`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const updateRoleService = async (id, data, access_token) => {
  try {
    return axios.post(`${api}/RoleManagement/EditStudyRole?Id=${id}`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const fetchAllSubscriptionsService = async (roleId, access_token) => {
  try {
    return axios.get(`${api}/RoleManagement/GetSubscriptionData?Id=${roleId}`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  } catch (err) {
    return err;
  }
};

export const updateRoleSubscriptionService = async (data, access_token) => {
  try {
    return axios.post(`${api}/RoleManagement/UpdateRoleSubscription`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const fetchAllReportsDataService = async (roleId, access_token) => {
  try {
    return axios.get(`${api}/RoleManagement/GetReportData?RoleId=${roleId}`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  } catch (err) {
    return err;
  }
};

export const updateRoleReportsService = async (data, access_token) => {
  try {
    return axios.post(`${api}/RoleManagement/UpdateReportStudyRole`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};
